import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import Reveal from "./Reveal";

const FAQS = [
  {
    q: "HOW MUCH DOES A HOT WATER SYSTEM REPLACEMENT COST IN PERTH?",
    a: "Every like-for-like swap-out price is listed right on this page — unit, labour and materials included, no call-for-a-quote runaround. Compact electric storage units sit at the budget end, family-size electric tanks run $1,479–$1,879, gas storage from $1,595, and continuous flow from $1,249.",
  },
  {
    q: "WHAT DOES 'LIKE-FOR-LIKE SWAP' ACTUALLY MEAN?",
    a: "We replace your existing unit with the same style, size and power source — gas for gas, electric for electric, storage for storage, continuous for continuous. That's what keeps the online price fixed and the job fast. Want to change size, brand or style? We can absolutely do it — it just needs pipe alterations and a quick custom quote first.",
  },
  {
    q: "CAN YOU REALLY REPLACE MY UNIT SAME DAY?",
    a: "Yes — same or next day across Perth, from Rockingham to Joondalup and beyond. Book a live time slot online or call 0475 776 555. Most swaps are done in 2–4 hours, so you're back in a hot shower the same day.",
  },
  {
    q: "SHOULD I REPAIR OR REPLACE MY HOT WATER SYSTEM?",
    a: "If it's under 8 years old and the fault is minor (thermostat, element, tempering valve), a repair usually makes sense — our diagnostic visit is $180. Over 8 years with a major fault? Replacement is almost always better value, and we'll show you both options before you decide.",
  },
  {
    q: "DO YOUR PRICES REALLY INCLUDE INSTALLATION?",
    a: "Yes — unit, labour and materials for a like-for-like swap, plus a qualified electrician for the electrical connection on electric units (be aware: some companies skip the sparky — that's illegal). Extras only if needed: valve kit $188–$299, cabinet installs +$350. Final price always confirmed before work starts.",
  },
  {
    q: "HOW DO I FIND MY CURRENT UNIT'S BRAND AND SIZE?",
    a: "Look for the identification sticker: electric storage units have it wrapped around the top of the cylinder, gas storage units have a data plate low on the opposite side of the access panel, and continuous flow units have it on the side of the case. Or use the finder above — answer 3 questions or upload a photo and we'll match you.",
  },
  {
    q: "MY SYSTEM IS MAKING A BANGING / BUBBLING NOISE — WHAT IS IT?",
    a: "That's usually 'kettling' — sediment buildup at the bottom of the tank trapping water that flashes to steam. We can flush and service it (from ~$350), but on older tanks replacement is often the smarter spend. Book a look and we'll give it to you straight.",
  },
  {
    q: "DO YOU OFFER FINANCE?",
    a: "Yep — flexible payment options including Afterpay, Zip and Brighte are available, because nobody budgets for a dead hot water system. Ask when you book.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="bg-tpeco-smoke border-t-4 border-tpeco-ink py-20 sm:py-28" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <Reveal>
          <span className="chip-brutal bg-tpeco-blue border-tpeco-blue text-white">STRAIGHT ANSWERS</span>
          <h2 className="mt-4 font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.95]" data-testid="faq-heading">
            QUESTIONS?<br /><span className="bg-tpeco-pink text-white px-3 rounded-2xl inline-block">SORTED.</span>
          </h2>
        </Reveal>
        <Reveal i={1} className="mt-10">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="card-brutal px-5 !border-b-[3px]" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="font-display uppercase text-xl sm:text-2xl text-left hover:no-underline hover:text-tpeco-blue py-4">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base font-semibold text-neutral-700 pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
